import { c as _c } from "react/compiler-runtime";
import Close from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_close.svg';
import styles from './modalCloseButton.module.scss';
import { ModalCloseButtonProps } from './types';
export const ModalCloseButton = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Close aria-hidden="true" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <button type="button" aria-label="Close" className={styles.iconButton} {...props}>{t1}</button>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};